import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Process from './components/Process';
import Pricing from './components/Pricing';
import CTABanner from './components/CTABanner';
import FAQ from './components/FAQ';
import Blog from './components/Blog';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PageLoader from './components/PageLoader';
import CookieConsent from './components/CookieConsent';
import Checkout from './components/Checkout';
import CheckoutSuccess from './pages/CheckoutSuccess';
import Subscribe from './pages/Subscribe';
import NotFound from './pages/NotFound';
import './index.css';

function HomePage() {
  return (
    <>
      <Hero />
      <Services />
      <About />
      <Process />
      <Pricing />
      <CTABanner />
      <FAQ />
      <Blog />
      <Contact />
    </>
  );
}

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = window.setTimeout(() => setIsLoading(false), 900);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <Router>
      <>
        <AnimatePresence mode="wait">
          {isLoading && <PageLoader key="loader" />}
        </AnimatePresence>

        <AnimatePresence>
          {!isLoading && (
            <motion.div
              key="app"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, ease: 'easeOut' }}
              className="min-h-screen bg-white dark:bg-dark transition-colors duration-300"
            >
              <Navbar />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/home" element={<HomePage />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/subscribe" element={<Subscribe />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
              <Footer />
              <CookieConsent />
            </motion.div>
          )}
        </AnimatePresence>
      </>
    </Router>
  );
}

export default App;
